<div class="container">
  <div class="main" fxLayout="column" fxLayoutAlign="center center" fxFill>
    <svg class="network-lights" aria-hidden="true">
      <g class="network-routes">
        <path d="M-263 49 L15 209 L293 49 L571 209 L849 49 L1127 209 L1405 49 L1683 209" />
        <path d="M-263 209 L15 49 L293 209 L571 49 L849 209 L1127 49 L1405 209 L1683 49" />
        <path d="M-263 339 L15 499 L293 339 L571 499 L849 339 L1127 499 L1405 339 L1683 499" />
        <path d="M-263 499 L15 339 L293 499 L571 339 L849 499 L1127 339 L1405 499 L1683 339" />
        <path d="M-263 629 L15 789 L293 629 L571 789 L849 629 L1127 789 L1405 629 L1683 789" />
        <path d="M-263 789 L15 629 L293 789 L571 629 L849 789 L1127 629 L1405 789 L1683 629" />
      </g>
      <g class="network-streaks">
        <path pathLength="1000" d="M-263 49 L15 209 L293 49 L571 209 L849 49 L1127 209 L1405 49 L1683 209" />
        <path pathLength="1000" d="M-263 209 L15 49 L293 209 L571 49 L849 209 L1127 49 L1405 209 L1683 49" />
        <path pathLength="1000" d="M-263 629 L15 789 L293 629 L571 789 L849 629 L1127 789 L1405 629 L1683 789" />
      </g>
    </svg>

    <div class="brand-watermark">
      <div class="brand-watermark-mark">
        <img src="assets/img/wazir/wazir-logo-full-transparent.png" alt="WAZIR ERP" />
        <p class="brand-credit">by alfasu</p>
      </div>
      <p class="brand-tagline">
        <span>Sistema de Gestão</span>
        <span>para Negócios e Indústrias</span>
      </p>
    </div>

    <p class="brand-message">Aquele que carrega o fardo</p>

    <form fxLayout="column" fxLayoutAlign="center center"
      class="login" fxFlexAlign="center"
      (ngSubmit)="onSubmit()" #form="ngForm">
      <div fxLayout="column" class="box" fxLayoutGap="10">
        <div class="brand" fxFlexAlign="center">
          <div class="login-title" aria-label="WAZIR ERP">
            <strong>WAZIR</strong> <span>ERP</span>
          </div>
        </div>
        <div class="login-heading">
          <span *ngIf="tenantLoginPending">SELEÇÃO DE USUÁRIO</span>
          <h1>{{ tenantLoginPending ? 'Continuar acesso' : 'Acessar sua conta' }}</h1>
          <p>
            {{ tenantLoginPending
              ? 'Escolha seu usuário do tenant para continuar.'
              : 'Informe seus dados de acesso para entrar no sistema.' }}
          </p>
        </div>
        <div *ngIf="tenantLoginPending" class="tenant-login-hint">
          Escolha seu usuario do tenant para continuar
        </div>
        <div fxFlex="none">
          <div fxLayout="column" fxLayoutGap="15" fxFill>
            <div class="company-mode" *ngIf="!tenantLoginPending && !companyFieldVisible">
              <button type="button" class="company-link" (click)="enableCompany()">
                Acessar com empresa
              </button>
            </div>
            <div fxFlex class="field company-field" *ngIf="!tenantLoginPending && companyFieldVisible">
              <label for="tenantField">EMPRESA <small>(opcional)</small></label>
              <div class="input-box">
                <mat-icon class="field-icon">business</mat-icon>
                <input
                  name="tenant"
                  id="tenantField"
                  autocomplete="organization"
                  [(ngModel)]="login.tenantKey"
                  list="core-remembered-companies"
                  placeholder="Digite a empresa" />
              </div>
              <datalist id="core-remembered-companies">
                <option
                  *ngFor="let company of rememberedCompanies"
                  [value]="company.slug">
                  {{ company.label }}
                </option>
              </datalist>
              <a
                class="company-link"
                *ngIf="login.tenantKey"
                (click)="changeCompany()"
                (keyup.enter)="changeCompany()"
                tabindex="0">Usar outra empresa</a>
              <a
                class="company-link"
                *ngIf="!login.tenantKey"
                (click)="useRoot()"
                (keyup.enter)="useRoot()"
                tabindex="0">Usar acesso por e-mail</a>
            </div>
            <!-- Campo Usuário -->
            <div fxFlex class="field">
              <label for="usernameField">USUÁRIO:</label>
              <div class="input-box">
                <mat-icon class="field-icon">person</mat-icon>
                <input
                  name="username"
                  id="usernameField"
                  autocomplete="username"
                  [(ngModel)]="login.identifier"
                  [attr.list]="tenantLoginPending ? 'core-tenant-users' : null"
                  placeholder="Digite seu usuário"
                  required />
              </div>
              <datalist id="core-tenant-users">
                <option
                  *ngFor="let candidate of tenantUserCandidates"
                  [value]="candidate.username">
                  {{ getTenantCandidateLabel(candidate) }}
                </option>
              </datalist>
            </div>

            <!-- Campo Senha -->
            <div fxFlex class="field">
              <label for="passwordField">SENHA:</label>
              <div class="input-box password-container">
                <mat-icon class="field-icon">lock</mat-icon>
                <input
                  name="password"
                  autocomplete="current-password"
                  [(ngModel)]="login.password"
                  placeholder="Digite sua senha"
                  required
                  [type]="showPassword ? 'text' : 'password'"
                  id="passwordField" />
                <i
                  class="material-icons password-toggle"
                  (click)="toggleShowPassword()"
                  (keyup.enter)="toggleShowPassword()"
                  tabindex="0"
                  role="button"
                  [attr.aria-label]="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
                  [ngClass]="{ 'visibility-off': showPassword }">
                  {{ showPassword ? 'visibility_off' : 'visibility' }}
                </i>
              </div>
            </div>
          </div>
        </div>

        <div fxFlex="none" fxLayout="row" fxLayoutGap="20" fxLayout.xs="row"
          fxLayoutGap.xs="10" fxLayoutAlign="space-between center"
          fxLayoutAlign.xs="space-between center"
          fxLayoutAlign.sm="space-between center"
          fxLayoutAlign.md="space-between center"
          fxLayoutAlign.lg="space-between center"
          fxLayoutAlign.xl="space-between center"
          class="recover-password-session">
          <mat-checkbox fxFlex="none">RELEMBRAR SENHA</mat-checkbox>
          <div fxFlex="none">
            <a [routerLink]="['/recuperar-senha']">ESQUECEU A SENHA?</a>
          </div>
        </div>

        <div class="button-session" [ngClass]="{ 'tenant-actions': tenantLoginPending }">
          <button
            *ngIf="tenantLoginPending"
            matRipple
            type="button"
            class="tenant-exit-button"
            [disabled]="loading"
            (click)="exitTenantLogin()">
            SAIR
          </button>
          <button matRipple type="submit" [disabled]="form.form.invalid || loading">
            ENTRAR
          </button>
        </div>
      </div>
    </form>
  </div>
  <div class="loading-overlay" *ngIf="loading">
    <div class="loading-content">
      <div class="loading-progress-text">{{ loadingProgress }}%</div>
      <mat-progress-bar mode="determinate" [value]="loadingProgress" class="loading-bar"></mat-progress-bar>
      <span class="loading-text">{{ loadingMessage }}</span>
      <span class="loading-hint" *ngIf="!showBackgroundOption">Aguarde enquanto configuramos o sistema</span>
      <button *ngIf="showBackgroundOption" type="button" class="btn-background" (click)="continueInBackground()">
        Continuar em segundo plano
      </button>
    </div>
  </div>
</div>
